module.exports = __webpack_public_path__ + "static/img/nav-theme-light.e765f4e4.svg";